var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.imgUrl}}),_c('div',{staticClass:"hr"}),_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }